import { lazyRouteComponent, createRoute } from '@tanstack/react-router';

import { processIncomingMobilityRoute } from '../route';

export const processIncomingMobilityRecapitulationRoute = createRoute({
	getParentRoute: () => processIncomingMobilityRoute,
	path: '/3-recapitulation',
	component: lazyRouteComponent(
		() => import('./ProcessIncomingMobilityRecapitulationPage'),
		'ProcessIncomingMobilityRecapitulationPage',
	),
});
